module.exports = __webpack_public_path__ + "img/upload-duotone.f3c1dc61.svg";